<script>
  import DiffProperty from './DiffProperty.svelte';

  export let layer;
  export let properties;

  let diffProperties = [];

  const collectProperties = p => {
    let collected = [];
    Object.entries(p).forEach(([k, v]) => {
      if (k === 'layout' || k === 'paint') {
        collected = collected.concat(collectProperties(v));
      } else {
        collected.push({ ...v, propertyId: k });
      }
    });
    return collected;
  };

  $: diffProperties = properties ? collectProperties(properties) : [];
</script>

<div class="diff-within-layer">
  {#if layer} <div class="layer">{layer}</div>{/if}
  <div class="properties">
    {#each diffProperties as { propertyId, current, compare }}
      <DiffProperty {propertyId} {current} {compare} />
    {/each}
  </div>
</div>

<style>
  .diff-within-layer {
    background: white;
    margin-bottom: 1em;
    border-radius: 10px;
  }

  .layer {
    color: white;
    background: #666;
    padding: 0.5em;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .properties {
    padding: 0.5em;
  }
</style>
